import { jsx } from '@amazon/vinyl-tsx'
import {
    BrowseMusicCollections,
    type BrowseMusicCollectionsDeps,
} from '@/browse/BrowseMusicCollections'

export type FindDeps = BrowseMusicCollectionsDeps

export interface FindProps {
    readonly deps: FindDeps
}

/**
 * Find / discover landing — mirrors green hornet's `FindLandingPage`.
 * Reuses `BrowseMusicCollections` with the same `music-home` data the home
 * page uses, but in a discovery framing.
 */
export function Find(props: FindProps) {
    return (
        <div className="findPage browseHome">
            <BrowseMusicCollections data={{ type: 'music-home' }} deps={props.deps} />
        </div>
    )
}
